//core
import { createSelector } from "@reduxjs/toolkit";

//store
import {RootState} from "../../../index";

// state
const summaryReportSelector = (state: RootState) => state.admin.cashier_report;

const summaryReportOptionsSelector = (state: RootState) => state.admin.cashier_report.options;
const summaryReportOptionsDataSelector = (state: RootState) => state.admin.cashier_report.options.data;
const summaryReportOptionsErrorSelector = (state: RootState) => state.admin.cashier_report.options.error;
const summaryReportOptionsFetchingSelector = (state: RootState) => state.admin.cashier_report.options.isFetching;

const summaryReportListSelector = (state: RootState) => state.admin.cashier_report.list;
const summaryReportListDataSelector = (state: RootState) => state.admin.cashier_report.list.data;
const summaryReportListErrorSelector = (state: RootState) => state.admin.cashier_report.list.error;
const summaryReportListFetchingSelector = (state: RootState) => state.admin.cashier_report.list.isFetching;

const summaryReportDownloadSelector = (state: RootState) => state.admin.cashier_report.download;
const summaryReportDownloadDataSelector = (state: RootState) => state.admin.cashier_report.download.data;
const summaryReportDownloadErrorSelector = (state: RootState) => state.admin.cashier_report.download.error;
const summaryReportDownloadFetchingSelector = (state: RootState) => state.admin.cashier_report.download.isFetching;
const summaryReportCurrenciesSelector = (state: RootState) => state.admin.cashier_report.currencies;
const summaryReportCurrenciesDataSelector = (state: RootState) => state.admin.cashier_report.currencies.data;
const summaryReportCurrenciesErrorSelector = (state: RootState) => state.admin.cashier_report.currencies.error;
const summaryReportCurrenciesFetchingSelector = (state: RootState) => state.admin.cashier_report.currencies.isFetching;

// const summaryReportPlatformsSelector = (state: RootState) => state.admin.cashier_report.platforms;
// const summaryReportPlatformsDataSelector = (state: RootState) => state.admin.cashier_report.platforms.data;
// const summaryReportPlatformsErrorSelector = (state: RootState) => state.admin.cashier_report.platforms.error;
// const summaryReportPlatformsFetchingSelector = (state: RootState) => state.admin.cashier_report.platforms.isFetching;

const summaryReportColumnsDataSelector = (state: RootState) => state.admin.cashier_report.columns.data;
const summaryReportColumnsErrorSelector = (state: RootState) => state.admin.cashier_report.columns.error;
const summaryReportColumnsFetchingSelector = (state: RootState) => state.admin.cashier_report.columns.isFetching;

//selectors
export const selectSummaryReport = createSelector(summaryReportSelector, (report) => report);

export const selectOptions = createSelector(summaryReportOptionsSelector, (options) => options);
export const selectOptionsData = createSelector(summaryReportOptionsDataSelector, (data) => data);
export const selectOptionsError = createSelector(summaryReportOptionsErrorSelector, (error) => error);
export const selectOptionsIsFetching = createSelector(summaryReportOptionsFetchingSelector, (isFetching) => isFetching);

//columns
export const selectColumnsData = createSelector(summaryReportColumnsDataSelector, (data) => data);
export const selectColumnsError = createSelector(summaryReportColumnsErrorSelector, (error) => error);
export const selectColumnsIsFetching = createSelector(summaryReportColumnsFetchingSelector, (isFetching) => isFetching);

export const selectList = createSelector(summaryReportListSelector, (list) => list);
export const selectListDataColumnsSort = createSelector(summaryReportListDataSelector, (data) => data?.columns.filter((el: any) => el.sort === true));
export const selectListData = createSelector(summaryReportListDataSelector, (data) => {
    return data;
});
export const selectListError = createSelector(summaryReportListErrorSelector, (error) => error);
export const selectListIsFetching = createSelector(summaryReportListFetchingSelector, (isFetching) => isFetching);

export const selectDownload = createSelector(summaryReportDownloadSelector, (data) => data);
export const selectDownloadData = createSelector(summaryReportDownloadDataSelector, (data) => data);
export const selectDownloadError = createSelector(summaryReportDownloadErrorSelector, (error) => error);
export const selectDownloadIsFetching = createSelector(summaryReportDownloadFetchingSelector, (isFetching) => isFetching);
export const selectCurrencies = createSelector(summaryReportCurrenciesSelector, (data) => data);
export const selectCurrenciesData = createSelector(summaryReportCurrenciesDataSelector, (data) => data);
export const selectCurrenciesError = createSelector(summaryReportCurrenciesErrorSelector, (error) => error);
export const selectCurrenciesIsFetching = createSelector(summaryReportCurrenciesFetchingSelector, (isFetching) => isFetching);

